import axios from "axios";
import { resetIdentity } from "../utils/impersonation.mjs";
import { pageDiagnostics } from "../utils/pageDiagnostics.mjs";
import { phaseDetailParams } from "../utils/phaseCadFiles.mjs";

import { captureException } from "@sentry/vue";

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (typeof error.response === "undefined") {
            window.vm.$toast.error("Errore di rete", { icon: "mdi-lan-disconnect" });
        }
        return Promise.reject(error);
    }
);

/*
 Work Api Plugin
*/

function WorkApi(url, store, version) {
    this.url = url;
    this.store = store;
    this.version = version;

    this.headers = function () {
        let headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-App-Version": this.version,
        };
        if (this.store.getters.token) {
            headers["Authorization"] = "Token " + this.store.getters.token;
        }
        return headers;
    };

    this.thumbmeta = function (url, params = {}) {
        let HTTP = axios.create({
            timeout: 120001,
        });
        // //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        return new Promise((resolve, reject) => {
            HTTP.get(url, { params: params })
                .then((response) => {
                    if (response.data !== null && response.data !== undefined) {
                        resolve(response);
                    } else {
                        this.ErrorRedirect(response);
                        reject(new Error(`apiget missing data ${url}`));
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    };
    this.sha256 = async function (message) {
        // encode as UTF-8
        const msgBuffer = new TextEncoder().encode(message.toLowerCase());

        // hash the message
        const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

        // convert ArrayBuffer to Array
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        // convert bytes to hex string
        return hashArray.map((b) => ("00" + b.toString(16)).slice(-2)).join("");
    };
    this.logout = function (app) {
        resetIdentity(app.$store);
    };

    this.impersonateLogin = function (token) {
        // A dedicated client prevents old Authorization headers and global redirects.
        return axios.create({ timeout: 30000 }).post(this.url + "impersonate-token/", {
            token,
            target: "dashboard",
        });
    };

    this.normalizeWorkUrl = function (url) {
        if (!url) return url;
        // Se resta in store un vecio URL http de Work, no femo content mixed su dashboard HTTPS.
        return url.replace(/^http:\/\/work\.mecomsrl\.com/i, "https://work.mecomsrl.com");
    };

    this.getAvatar = async function () {
        let url = "";
        let profile = "";
        if (this.store.getters.isLoggedIn) {
            const userdata = this.store.getters.userdata || {};
            const avatarFromPayload = this.normalizeWorkUrl(userdata.avatar_url);

            if (avatarFromPayload) {
                url = avatarFromPayload;
            } else {
                const baseUrl = this.url.replace(/\/api\/?$/, "/").replace(/\/$/, "");
                const username = encodeURIComponent((userdata.username || "utente").trim() || "utente");
                url = `${baseUrl}/wm/avatar/${username}/`;
            }

            profile = url;
            return {
                avatar: url,
                profile: profile,
            };
        }
    };
    this.tokenlogin = async function (token) {
        let res = await axios.post(this.url + "user-token/", { token: token }, { timeout: 120001 });
        if (res.status === 200) {
            let vm = window.vm;
            let authUser = {};
            authUser.data = res.data;
            authUser.token = res.data.token;
            vm.$store.commit("isLoggedIn", true);
            vm.$store.commit("userdata", authUser.data);
            vm.$store.commit("token", authUser.token);
            return true;
        } else {
            return false;
        }
    };

    this.put = function (url, data, silent = false) {
        let HTTP = axios.create({
            baseURL: this.url,
            headers: this.headers(),
            timeout: 120001,
        });
        // //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        if (silent) {
            return HTTP.put(url, data);
        }
        return HTTP.put(url, data).catch(this.ErrorNoRedirect);
    };
    this.post = function (url, data, silent = false, custom_headers = {}, options = {}) {
        let headers = this.headers();
        if (custom_headers) {
            headers = { ...headers, ...custom_headers };
        }
        let HTTP = axios.create({
            baseURL: this.url,
            headers: headers,
            timeout: 120001,
        });
        // //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        if (silent) {
            return HTTP.post(url, data, options);
        } else {
            return HTTP.post(url, data, options).catch(this.ErrorNoRedirect);
        }
    };

    this.patch = function (url, data, silent = false) {
        let HTTP = axios.create({
            baseURL: this.url,
            headers: this.headers(),
            timeout: 120001,
        });
        ////axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        if (silent) {
            return HTTP.patch(url, data);
        }
        return HTTP.patch(url, data).catch(this.ErrorNoRedirect);
    };

    this.getsilent = function (url) {
        let HTTP = axios.create({
            baseURL: this.url,
            headers: this.headers(),
            timeout: 120001,
        });
        ////axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        return HTTP.get(url).catch(function (error) {
            console.log(error);
        });
    };
    this.form = function (url, callback) {
        /*
        Prova di build automatico form
         */
        let formConfig = { rules: {}, elements: [] };
        let HTTP = axios.create({
            baseURL: this.url,
            headers: this.headers(),
            timeout: 120001,
        });
        ////axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        HTTP.options(url)
            .then((res) => {
                let items = res.data.actions.PUT;
                for (let item_id in items) {
                    let item = items[item_id];
                    // aggiungo il campo su elements
                    let element = {
                        tag: "el-input",
                        item: { label: "" },
                        detail: { name: item_id },
                    };
                    let rules = [];
                    element["item"]["label"] = item.label;
                    element["detail"]["name"] = item_id;

                    if (item.type === "integer") {
                        element["detail"]["type"] = "integer";
                    }

                    formConfig["elements"].push(element);

                    // aggiungo le regole
                    if (item.required) {
                        rules.push({ required: true, message: "Campo obbligarorio" });
                    }
                    if (item.max_length) {
                        rules.push({
                            max: item.max_length,
                            message: "Lunghezza massima " + item.max_length + " caratteri",
                        });
                    }
                    if (rules.length > 0) {
                        // aggiungo le regole se presenti
                        formConfig["rules"][item_id] = rules;
                    }
                }
                callback(formConfig);
            })
            .catch((error) => {
                this.$toast.error(error, { icon: "mdi-alert", timeout: 10000 });
            });
    };

    this.ErrorRedirect = function (error) {
        if (error.response !== undefined) {
            if (error.response.status === 401) {
                if (window.vm.$route.path !== "/login") {
                    // Autorizzazione richiesta per questa pagina !
                    window.vm.$toast.error("Autorizzazione Richiesta per questa pagina: " + window.vm.$route.path, {
                        icon: "mdi-alert",
                    });
                    window.vm.$router.push({
                        name: "Login",
                        query: { next: window.vm.$route.path },
                    });
                    // eseguoil logout , probabilmente è scaduto il token
                    if (this.store.getters.isLoggedIn) {
                        this.logout(window.vm);
                    }
                }
            } else if (error.response.status === 403) {
                // Autorizzazione richiesta per questa pagina !
                if (window.vm.$route.path !== "/login") {
                    window.vm.$toast.error("Livello Autorizzazione non Sufficente: " + window.vm.$route.path, {
                        icon: "mdi-alert",
                    });
                    window.vm.$router.push({
                        name: "Login",
                        query: { next: window.vm.$route.path },
                    });
                }
            } else if (error.response.status === 404) {
                // Missing Ojetto
                window.vm.$toast.error("Oggetto non trovato", {
                    icon: "mdi-alert",
                    timeout: 5000,
                    showClose: true,
                });
            } else if (error.response.status === 204) {
                // Empty response
                console.log(error.response);
            } else {
                window.vm.$toast.error("Errore Applicazione ", { icon: "mdi-alert" });
            }
        } else {
            window.vm.$toast.error("Errore Connessione ", { icon: "mdi-alert" });
        }
    };

    // Axios ciama el callback senza receiver: la arrow conserva l'istanza WorkApi.
    this.ErrorNoRedirect = (error) => {
        if (error.response !== undefined) {
            if (error.response.status === 401) {
                if (window.vm.$route.path !== "/login") {
                    // Autorizzazione richiesta per questa pagina !
                    window.vm.$toast.error("Autorizzazione Richiesta per questa pagina: " + window.vm.$route.path, {
                        icon: "mdi-alert",
                        timeout: 10000,
                    });
                    // resetto il token per sicurezza
                    if (this.store.getters.isLoggedIn) {
                        this.logout(window.vm);
                    }
                }
            } else if (error.response.status === 403) {
                // Autorizzazione richiesta per questa pagina !
                if (window.vm.$route.path !== "/login") {
                    window.vm.$toast.error("Livello Autorizzazione non Sufficente: " + window.vm.$route.path, {
                        icon: "mdi-alert",
                        timeout: 10000,
                    });
                }
            } else {
                window.vm.$toast.error("Errore Applicazione ", { icon: "mdi-alert" });
            }
        } else {
            window.vm.$toast.error("Errore Connessione ", { icon: "mdi-alert" });
        }
    };

    this.delete = function (url, data = undefined, silent = false) {
        let HTTP = axios.create({
            baseURL: this.url,
            headers: this.headers(),
            timeout: 120001,
        });
        //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        const request = HTTP.delete(url, data === undefined ? undefined : { data });
        if (silent) {
            return request;
        }
        return request.catch(this.ErrorNoRedirect);
    };

    this.bot = function (cmd, query, channel = null, options = {}) {
        let url = "/bot/" + cmd + "/";
        let headers = this.headers();
        if (channel) {
            headers["X-Channel-Name"] = channel;
        }
        let HTTP = axios.create({
            baseURL: this.url,
            headers: headers,
            timeout: 120001,
        });
        //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        const request = HTTP.post(url, { query: query });
        return options.silent ? request : request.catch(this.ErrorNoRedirect);
    };

    this.get = async function (url, params = {}, silent = false, abortController = null, options = {}) {
        let diagnostic = null;
        try { diagnostic = pageDiagnostics.begin(url, this.url, this.store); } catch (_) { /* Diagnostics must not block an application request. */ }
        let HTTP = axios.create({
            baseURL: this.url,
            headers: { ...this.headers(), ...(diagnostic ? { "X-Work-Diagnostics": diagnostic.sessionId, "X-Work-Diagnostics-Client": diagnostic.clientId, "X-Work-Diagnostics-Context": diagnostic.navigationId } : {}) },
            timeout: 120001,
            signal: abortController ? abortController.signal : null,
        });
        const ignoreSentryStatuses = options.ignoreSentryStatuses || [];
        const ignoreGlobalErrorStatuses = options.ignoreGlobalErrorStatuses || [];
        const resolveErrorStatuses = options.resolveErrorStatuses || [];
        const notModifiedStatuses = options.notModifiedStatuses || [304];
        //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        return new Promise((resolve, reject) => {
            HTTP.get(url, {
                params: phaseDetailParams(url, params, {}, options),
                ...(options.timeout ? { timeout: options.timeout } : {}),
                ...(options.responseType ? { responseType: options.responseType } : {}),
            })
                .then((response) => {
                    try { if (diagnostic) diagnostic.finish(response); } catch (_) { /* Preserve the original response. */ }
                    return response;
                }, (error) => {
                    try { if (diagnostic) diagnostic.finish(error.response, error); } catch (_) { /* Preserve the original error handling. */ }
                    throw error;
                })
                .then((response) => {
                    if (response.data !== null && response.data !== undefined) {
                        resolve(response);
                    } else {
                        this.ErrorRedirect(response);
                        reject(new Error(`apiget missing data ${url}`));
                    }
                })
                .catch((error) => {
                    if (silent) {
                        // Outcome recovery needs the original status without global UI effects.
                        if (options.rejectSilentErrors) reject(error);
                        else resolve({});
                    } else if (error.code === "ERR_CANCELED") {
                        console.log("error", error.message, url);
                        resolve(undefined);
                    } else {
                        const status = error?.response?.status;
                        if (notModifiedStatuses.includes(status)) {
                            resolve(undefined);
                            return;
                        }
                        if (resolveErrorStatuses.includes(status)) {
                            resolve(error.response);
                            return;
                        }
                        if (!ignoreSentryStatuses.includes(status)) {
                            try { captureException(error); }
                            catch (_) { console.log("Segnalazione errore API non disponibile."); }
                        }
                        if (!ignoreGlobalErrorStatuses.includes(status)) {
                            try { this.ErrorRedirect(error); }
                            catch (_) { console.log("Notifica errore API non disponibile."); }
                        }
                        // Always settle the caller, including when reporting/notification fails.
                        reject(error);
                    }
                });
        });
    };

    this.updatepass = function (form) {
        let HTTP = axios.create({
            baseURL: this.url,
            headers: this.headers(),
            timeout: 120001,
        });
        //axiosRetry(HTTP, {retries: 10, retryDelay: //axiosRetry.exponentialDelay});
        return HTTP.post("/rest-auth/password/change/", form);
    };
    this.login = function (form) {
        return axios.post(this.url + "token-auth/", form, { timeout: 120001 });
    };
}

export default {
    install: (app, options) => {
        let api = new WorkApi(options.url, options.store, options.version);
        window.work_api = api;
        app.prototype.$work = api;
    },
};
